import * as types from './mutation-types'
import Vue from 'vue'
import { IAdminFleetState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbFleet } from '@/models/alodb/AloDbFleet';
import glider from '@/api/glider';
import { AloDbFleetConfig } from '@/models/alodb/AloDbFleetConfig';
import {i18n} from '@/locale/vueI18n'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem';
import { WobAdminChanged } from '@/models/wob/WobAdminChanged';
import deepEqual from 'deep-equal'  

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IAdminFleetState> = {
     
    //Gestion des recherches de missions
    [types.ADMINFLEET_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.AdminFleet.Title').toString()}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_SUCCESS]: (state, adminFleets:Array<AloDbFleet>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.AdminFleet.Title').toString()}).toString()
        adminFleets.forEach(f => Vue.set(state.adminFleetsById,f.FLE_ID!,f))
        state.adminFleetsId = adminFleets.map(f => f.FLE_ID!)
        state.adminFleetLoading = false             
    },
    [types.ADMINFLEET_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.AdminFleet.Title').toString()}).toString()
        state.adminFleetsId = []
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} ${itemId}`}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.AdminFleet.Title').toString()}).toString()
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_SELECT_DETAIL_SUCCESS]: (state,adminFleet:AloDbFleet) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} ${adminFleet.FLE_ID}`}).toString()    
        //1, on met à jour de m'adminFleet dans la liste des adminFleets
        Vue.set(state.adminFleetsById,adminFleet.FLE_ID!,adminFleet)        
        if(!state.adminFleetsId.includes(adminFleet.FLE_ID!)) state.adminFleetsId.push(adminFleet.FLE_ID!)        
             
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_SELECT_DETAIL]: (state,adminFleet:AloDbFleet) => {                
        state.originalAdmAdminFleet = adminFleet
        state.modifiedAdmAdminFleet = new AloDbFleet(adminFleet)
    },
    [types.ADMINFLEET_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} ${libelle}`}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.AdminFleet.Title').toString()}).toString()
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} ${libelle}`}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_DELETE_SUCCESS]: (state,fleetId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} ${fleetId}`}).toString()                

        const index = state.adminFleetsId.findIndex(l => l == fleetId)
        state.adminFleetsId.splice(index == -1 ? state.adminFleetsId.length : index, index == -1 ? 0 : 1)
        state.adminFleetsById[fleetId] && Vue.delete(state.adminFleetsById,fleetId)
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.AdminFleet.Title').toString()}).toString()
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmAdminFleet = {...state.modifiedAdmAdminFleet,...newProperties}
    },
    [types.ADMINFLEET_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.ADMINFLEET_CONFIG_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} config`}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_CONFIG_SUCCESS]: (state, configsFleet:Array<AloDbFleetConfig>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} config`}).toString()
        const dicFleets = state.configsFleet.reduce((acc,c) => {
            acc[c.FLC_ID!] = c
            return acc
        },{} as {[index:number]:AloDbFleetConfig})
                
        const newConfigs = [] as AloDbFleetConfig[]
        configsFleet.forEach(f => {
            if(f.FLC_IS_CURRENT && f.FLE_ID == state.originalAdmAdminFleet.FLE_ID) state.currentConfig = f
            if(!dicFleets[f.FLC_ID!])  newConfigs.push(f)
        })
        state.configsFleet = [...state.configsFleet,...newConfigs]
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_CONFIG_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} config`}).toString()        
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_CONFIG_DETAIL_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} detail config`}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_CONFIG_DETAIL_SUCCESS]: (state, configFleet:AloDbFleetConfig) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} detail config`}).toString()
        //1, on met à jour de m'adminFleet dans la liste des adminFleets
        const index = state.configsFleet.findIndex(c => c.FLC_ID == configFleet.FLC_ID)
        state.configsFleet.splice(index == -1 ? state.configsFleet.length : index, index == -1 ? 0 : 1, configFleet)
        if(configFleet.FLC_IS_CURRENT && configFleet.FLE_ID == state.originalAdmAdminFleet.FLE_ID) state.currentConfig = configFleet
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_CONFIG_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} detail config`}).toString()             
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_SAVE_CONFIG_REQUEST]: (state,config:AloDbFleetConfig) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} detail config`}).toString()
        state.adminFleetLoading = true
    },
    [types.ADMINFLEET_SAVE_CONFIG_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:`${i18n.t('Admin.AdminFleet.Title').toString()} detail config`}).toString()
        state.adminFleetLoading = false
    },
    [types.ADMINFLEET_SHOW_HISTOCONFIG]: (state,config:AloDbFleetConfig) => {        
        state.histoConfig = config
    },
    [types.ADMINFLEET_HIDE_HISTOCONFIG]: state => {        
        state.histoConfig = new AloDbFleetConfig()
    },    
    [types.ADMINFLEET_EXTERNAL_UPDATE]: (state, wob: WobAdminChanged<AloDbFleet>) => {        
        //on met à jour ou ajoute l'objet dans la liste
        if(wob.actionType == "Deleted") {
            const index = state.adminFleetsId.findIndex(m => m == wob.oldAloDbItem.FLE_ID)
            state.adminFleetsId.splice(index == -1 ? state.adminFleetsId.length : index, index == -1 ? 0 : 1)
            state.adminFleetsById[wob.oldAloDbItem.FLE_ID!] && Vue.delete(state.adminFleetsById,wob.oldAloDbItem.FLE_ID!)
        }
    }
}


export default mutations
